import React, { useEffect, useState } from "react";
import { GeneratedResult, GeneratePromptModalProps } from "../types";
import style from "../style.module.scss"
import { ReactComponent as PromptIcon } from '../../../../../assets/svg/ai-agents/Group 38029 (1).svg'
import { ReactComponent as GeneratePromptIcon } from '../../../../../assets/svg/ai-agents/Group 38029 (2).svg'
import { ReactComponent as FailureIcon } from '../../../../../assets/svg/ai-agents/Group 37.svg'
import { ReactComponent as EmptyPrompt } from '../../../../../assets/svg/ai-agents/empty-prompt.svg'
import LoadingScreen from "../loading";
import { Input, Icon } from "antd";
import { Http } from "../../../../../helpers/axois";
import { logger } from "../../../../../constant/winston";
import { motion } from "framer-motion";
import { pageVariants1 } from "../framerAnimations";
import { APIURL } from "../../../../../constant/common";
const {TextArea} = Input;

export const PromptGallery = ({ setVisible, setAgentDetails, agentDetails, appId, setInstructions }: GeneratePromptModalProps) => {
    const [showGeneratePrompt, setShowGeneratePrompt] = useState<boolean>(false)
    const [isLoading, setIsLoading] = useState<boolean>(false)
    const [generatedResult, setGeneratedResult] = useState<GeneratedResult>({
        prompt: ""
    })
    const [showError, setShowError] = useState(false)
    const [promptList, setPromptList] = useState<{id: string, name: string, prompt: string}[]>([])
    const [prompt, setPrompt] = useState<string>("")
    const [searchValue, setSearchValue] = useState<string>("");
    const [promptEmpty, setPromptEmpty] = useState<string>("")

    const generate = () => {
        if(!prompt){
            setPromptEmpty("Please enter instructions")
            return
        }
        setIsLoading(true)
        setShowError(false)
        setPromptEmpty("")

        const baseURL = `https://${APIURL.split("/")[2]}`
        const endpoint = `${baseURL}/tars/v1/generate-prompt`
        Http.post(endpoint, {content: prompt}).subscribe((res: any) => {
            if (res.prompt) {
                setGeneratedResult({prompt: res?.prompt || "",})
                setIsLoading(false)
            } else {
                logger.error(res);
            }
        },(err) => {
            setIsLoading(false)
            setShowError(true)
        })
    }

    
    const getPrompts = () => {
        Http.get(`/apps/${appId}/prompts`).subscribe((res: any) => {
            if (res?.prompts) {
                setPromptList([{ name: "generator", id: "generator", prompt: ""}, ...res.prompts])
            }else{
                setPromptList([{ name: "generator", id: "generator" , prompt: ""}])
            }
        }, (err) => {
            console.log({ err })
        })
    }
    
    useEffect(() => {
        getPrompts();
    }, [])
    
    const filteredPrompts = promptList?.filter((prompt) =>
        prompt.name.toLowerCase().includes(searchValue.toLowerCase())    
    );

    const list = searchValue ? filteredPrompts : promptList
    return (
        <>
            {!showGeneratePrompt && <div style={{padding: 15}}>
                <Input
                    value={searchValue}
                    className="prompt-gallery-search"
                    prefix={<Icon type="search" />}
                    onChange={(e) => { setSearchValue(e.target.value) }} placeholder="Search Prompt" />    
            </div>}
            {!showGeneratePrompt && <div className={style.agentListContainer} style={{ overflow: "auto", maxHeight: 600, cursor: "pointer" }}>
                {!showGeneratePrompt &&  list.map((agent) => {
                    return (
                        <div>
                            {agent.name === "generator" &&
                                <div className={style.generateLayout} onClick={() => { setShowGeneratePrompt(true) }}>
                                    <PromptIcon />
                                    <p className={style.generateLayoutText}>Generate Prompt</p>
                                </div>
                            }
                            {agent.name !== "generator" && <div onClick={() => {
                                setInstructions(agent.prompt)
                                setAgentDetails && agentDetails && setAgentDetails({...agentDetails, prompt: agent.prompt})
                                setVisible(false)
                            }} className={style.galleryPromptCard}>
                                <h2 className={style.galleryPromptHeader}>{agent.name}</h2>
                                <div className={style.galleryPrompt}>{agent.prompt}</div>
                            </div>}
                        </div>
                    )
                })}
            </div>}
            {searchValue && list?.length === 0 && 
                <div style={{height: "100%"}}>
                    <div className={style.aiAgentsEmptyContainer} style={{height: "60%"}}>
                        <EmptyPrompt style={{marginBottom: 18}}/>
                        <h1 style={{ color: "#000000", fontWeight: 700, fontSize: 16, marginBottom: 18 }}>No Matches Found for Your Search</h1>
                        <div style={{ width: 330, textAlign: "center", color: "#292D32", fontSize: 14, marginBottom: 18 }}>Try a different search or explore our prompt gallery for inspiration.</div>
                    </div>
                </div>
            }
            {showGeneratePrompt &&
                <motion.div
                    initial="hidden"
                    animate="visible"
                    exit="exit"
                    variants={pageVariants1}
                >
                    <div className={style.promptContainer} style={{ height: 520 }}>
                        <div className={style.leftColumn}>
                            <p className={style.generateHeadertext}>Generate Prompt</p>
                            <div className={style.generateLayoutDesc}>
                                The Prompt Generator leverages the configured model to enhance prompt quality and structure. Please provide clear and detailed instructions.
                            </div>

                            <div className={style.generatePromptContainer}>
                                <div className={style.generatePromptHeader}>Instructions</div>

                                <TextArea
                                    className="contentEditor"
                                    draggable={false}
                                    // value={}
                                    onChange={(e) => {
                                        const text = (e.target.value);
                                        setPrompt(text)
                                        setPromptEmpty("")
                                    }}
                                    style={{ boxShadow: "none", border: "none", outline: "none", resize: "none", height: 240 }} />
                            </div>
                            {promptEmpty && <div className={style.errorMessage}>{promptEmpty}</div>}
                            <div className={style.buttonWrapper}>
                                <button disabled={isLoading} className={style.generateButton}
                                    style={{
                                        background: isLoading ? "#B1B5BD" : "#15808C",
                                        border: isLoading ? "1px solid #B1B5BD" : "1px solid #15808C",
                                        cursor: isLoading ? "not-allowed" : "pointer"
                                    }} onClick={() => { generate() }}>Generate</button>
                            </div>
                        </div>

                        <div className={style.straightLineDivider}></div>

                        <div className={style.rightColumn} style={{ alignItems: generatedResult.prompt ? "flex-start" : "center", paddingTop: 20 }}>
                            {!isLoading && !showError && !generatedResult.prompt && <div className={style.previewContainer}>
                                <GeneratePromptIcon className={style.icon} />
                                Enter your use case on the left, and the GenAI preview will appear here.
                            </div>}

                            {!isLoading && showError &&
                                <div className={style.previewContainer} style={{ color: "#BE0202" }}>
                                    <FailureIcon className={style.icon} />
                                    Something went wrong
                                </div>
                            }

                            {isLoading && !showError &&
                                <LoadingScreen />
                            }

                            {!isLoading && generatedResult.prompt &&
                                <motion.div
                                    initial="hidden"
                                    animate="visible"
                                    exit="exit"
                                    variants={pageVariants1}
                                    className={style.resultContainer}>
                                    <div className={style.generatePromptContainer} style={{ height: 500 }}>
                                        <div className={style.generatePromptHeader}>Instructions</div>
                                        <p style={{ padding: 10, color: "#292D32", fontSize: 14, fontWeight: 500, overflow: "auto", maxHeight: 420 }}>{generatedResult.prompt}</p>
                                    </div>
                                </motion.div>
                            }
                        </div>
                    </div>
                    <div className={style.divider}></div>

                    <div className={style.modalFooter}>
                        <button className={style.modalFooterBtn} onClick={() => { setVisible(false) }}>Cancel</button>
                        {generatedResult.prompt && <button className={style.modalFooterApplyBtn} onClick={() => {
                            setInstructions(generatedResult.prompt)
                            agentDetails && setAgentDetails && setAgentDetails({ ...agentDetails, prompt: generatedResult.prompt })
                            setVisible(false)
                        }}>Apply</button>
                        }
                    </div>
                </motion.div>
            }
        </>
    )
}